import React from 'react';
import { Link } from 'react-router-dom';
import { apiGetComments } from '../../api/api';
import { timestampToDateString, timestampToTimeString } from '../../utility/date_functions';

const MAX_PREVIEW_LENGTH = 97;

class PostCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numberOfComments: null
        };
    }

    async componentDidMount() {
        const commentsResponse = await apiGetComments(this.props.uuid);
        if (!commentsResponse.ok) {
            this.setState({
                ...this.state,
                numberOfComments: 0
            });

            return;
        }

        const commentsJson = await commentsResponse.json();

        this.setState({
            ...this.state,
            numberOfComments: commentsJson.comments.length,
        });
    }

    render() {
        const dateString = timestampToDateString(this.props.timestamp);
        const timeString = timestampToTimeString(this.props.timestamp);

        return (
            <div style={{border: '2px solid black', borderRadius: "10px", padding: '10px', marginBottom: '10px', marginLeft: '50px', marginRight: '50px'}}>
                <div>
                    <h3><Link to={`/post/${this.props.uuid}`}>{this.props.title}</Link></h3>
                    <p>{this.props.body.length > MAX_PREVIEW_LENGTH ? this.props.body.slice(0, MAX_PREVIEW_LENGTH) + "..." : this.props.body}</p>
                    <p style={{fontStyle: 'italic'}}>{this.state.numberOfComments !== null ? this.state.numberOfComments : "..."} comment{this.state.numberOfComments !== 1 ? 's' : ''}</p>
                </div>
                <div>
                    <p>Posted {dateString} {timeString} by {this.props.user}</p>
                </div>
            </div>
        )
    }
}

export default PostCard;
